// FormatTime.js
const FormatTime = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  let hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  const period = hours >= 12 ? "PM" : "AM";
  if (hours > 12) hours -= 12;
  else if (hours === 0) hours = 12;

  return `${hours}:${minutes} ${period}`;
};

export default FormatTime;